<template>
    <section id="cta-content-savings">
        <div class="cta-content savings-cta">
            <div class="container text-center">
                <h2 class="gtitle fw-bold mb-4 open-sans savings-cta-title">
                    Broad commercial and Medicaid coverage.<sup>1,2</sup> JORNAY
                    PM offers a savings program for eligible, commercially
                    insured patients.
                </h2>
                <p class="fw-semibold">
                    If you need assistance finding a particular dosage strength,
                    call our Pharmacy Locator service at 1-877-938-4766,
                    Monday-Friday 8
                    <span class="ampm-text">AM</span> to 9
                    <span class="ampm-text">PM</span> ET.
                </p>
            </div>
        </div>

        <CTABanner
            :twoButtons="true"
            :onlyBanner="true"
            :isExternal="false"
            :addTopBanner="false"
            :bannerData="{
                bannerText: 'See Downloadable Resources',
                href: '/resources',
            }"
            :topBannerData="{
                title: 'Connect your patients with savings',
                textBtn: 'Review the Savings Brochure',
                href: '/savings-brochure.pdf',
            }"
        />
    </section>
</template>

<script>
import CTABanner from '../CTABanner.vue';

export default {
    components: {
        CTABanner,
    },
    data() {
        return {};
    },
};
</script>
